module.exports = __webpack_public_path__ + "img/wifi-block-oak.92cac746.png";